import React from 'react';
import FormField from 'Utils/FormField';
import {
  Dialog, TextInput, toaster,
} from 'evergreen-ui';
import { useUserResetPasswordMutation } from 'Services/api/usersApi';

export function UserPasswordDialog({
  user, isShown, setIsShown,
}) {
  const [password, setPassword] = React.useState('');
  const [resetPassword, { isLoading: isDeleting }] = useUserResetPasswordMutation();

  const setUserPassword = React.useCallback(async () => {
    if (password.length > 6) {
      await resetPassword({ id: user.username, password }).unwrap();
      toaster.success('Пароль пользователя изменен!');
      setIsShown(false);
    } else {
      toaster.danger('Пароль должен быть больше 6-ти символов!');
    }
  }, [password, resetPassword, setIsShown, user.username]);

  return (
    <Dialog
      isShown={isShown}
      isConfirmLoading={isDeleting}
      onCloseComplete={() => setIsShown(false)}
      title="Установка пароля для пользователя"
      confirmLabel="Задать пароль"
      cancelLabel="Отмена"
      onConfirm={setUserPassword}
    >
      <FormField label="Пароль должен быть больше 6-ти символов">
        <TextInput
          width="100%"
          placeholder="Введите пароль..."
          isInvalid={password?.length < 7}
          onChange={(e) => setPassword(e.target.value)}
        />
      </FormField>
    </Dialog>
  );
}
